import { render, staticRenderFns } from "./MovieAbout.vue?vue&type=template&id=74e1ef8a&scoped=true&"
import script from "./MovieAbout.vue?vue&type=script&lang=js&"
export * from "./MovieAbout.vue?vue&type=script&lang=js&"
import style0 from "./MovieAbout.vue?vue&type=style&index=0&id=74e1ef8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e1ef8a",
  null
  
)

export default component.exports